import { resourceCheckIn, resourceNotCheckedIn } from '../../api/resources';

const state = {
    locationsList: [],
    beginTime: '--:--',
    endTime: '--:--',
    timeoutId: null,
};

const mutations = {
    SET_CHECKIN_TIME(state, { beginTime, endTime }) {
        state.beginTime = beginTime;
        state.endTime = endTime;
    },

    SET_LOCATIONS(state, val) {
        state.locationsList = val;
    },

    SET_TIMEOUT(state, val) {
        state.timeoutId = val;
    },

    CLEAR_TIMEOUT(state) {
        state.timeoutId = null;
    },
};

/**
 * Calculate interval between requests
 * @param start time
 * @param end time
 * @return {int}
 */
function calcInterval(start, end) {
    let diff;
    let time = new Date();
    let userTime = time.getHours() * 60 * 60 + time.getMinutes() * 60;
    let [beginTimeHH, beginTimeSS] = start.split(':');
    let [endTimeHH, endTimeSS] = end.split(':');

    let beginTime = beginTimeHH * 60 * 60 + beginTimeSS * 60;
    let endTime = endTimeHH * 60 * 60 + endTimeSS * 60;

    if ((userTime > beginTime && userTime > endTime) || userTime === endTime) {
        diff = 86400 - userTime + beginTime;
    }

    if (userTime > beginTime && userTime < endTime) {
        diff = endTime - userTime;
    }

    if (userTime < beginTime && userTime < endTime) {
        diff = beginTime - userTime;
    }

    if (userTime === beginTime) {
        diff = endTime - userTime;
    }

    if (beginTime > endTime && userTime > beginTime) {
        diff = 86400 - userTime + endTime;
    }

    if (beginTime > endTime && userTime < beginTime) {
        diff = beginTime - userTime;
    }

    return (diff *= 1000);
}

const actions = {
    /**
     * Load information about check in time
     * @param commit
     * @param cancelToken
     * @returns {Promise}
     */
    loadCheckIn({ commit }, { cancelToken }) {
        return resourceCheckIn({ cancelToken })
            .then(response => response.data)
            .then(data => {
                let beginTime = data.begin_time.slice(0, 5);
                let endTime = data.end_time.slice(0, 5);
                commit('SET_CHECKIN_TIME', { beginTime, endTime });
            });
    },

    /**
     * Load information about not checked in (locations list and devices)
     * @param commit
     * @param {number} id
     * @returns {Promise}
     */
    loadNotCheckedIn({ commit }, { id }) {
        return resourceNotCheckedIn({ id })
            .then(response => response.data)
            .then(data => commit('SET_LOCATIONS', data));
    },

    /**
     * Common chain for check in
     * @param dispatch
     * @param id
     * @param cancelToken
     * @returns {Promise}
     */
    loadNotCheckedInInfo({ dispatch }, { id, cancelToken }) {
        return dispatch('loadCheckIn', { cancelToken }).then(() => {
            return dispatch('loadNotCheckedIn', { id }).then(() => dispatch('setNotCheckedInTimer', { id }));
        });
    },

    /**
     * Set timeout for next update information about not checked in
     * @param state
     * @param commit
     * @param dispatch
     * @param id
     */
    setNotCheckedInTimer({ state, commit, dispatch }, { id }) {
        if (state.timeoutId) {
            dispatch('clearTimeoutId');
        }
        let timeoutId = setTimeout(
            () => dispatch('loadNotCheckedInInfo', { id }).catch(() => {}),
            calcInterval(state.beginTime, state.endTime)
        );
        commit('SET_TIMEOUT', timeoutId);
    },

    /**
     * Clear timeout id
     * @param state
     * @param commit
     */
    clearTimeoutId({ state, commit }) {
        clearTimeout(state.timeoutId);
        commit('CLEAR_TIMEOUT');
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
